import fetch from '../utils/fetch-json';
import { FETCHING_EVENT, FETCHING_EVENT_FAILED, GOT_EVENT } from '../constants/index';
import { getEvent } from './event-reducer';

export const fetchEvent =
    (eventId) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/event/${eventId}`);
        const event = getEvent(state, eventId);

        if (event) {
            return;
        }
        dispatch({ type: FETCHING_EVENT });

        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) =>
                dispatch({
                    type: GOT_EVENT,
                    data: response.body,
                })
            )
            .catch((error) =>
                dispatch({
                    type: FETCHING_EVENT_FAILED,
                    data: error.body,
                })
            );
    };

export const fetchEventStatsBySchool =
    ({ eventId, schoolOrgNumber }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/event/${eventId}/stats/school/${schoolOrgNumber}`;

        return fetch({
            url: fullUrl,
            options: {
                method: 'GET',
            },
            dispatch,
            getState,
        });
    };

export const fetchEventStats =
    ({ eventId }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/event/${eventId}/stats`;

        return fetch({
            url: fullUrl,
            options: {
                method: 'GET',
            },
            dispatch,
            getState,
        });
    };
